import { useLang } from 'hooks/lang';

import { getStatusConfig, InvoiceProjectByStatus, loaders } from 'entities';

import { Link, Dot } from 'components/Blocks';
import { FolderIcon, WarningIcon } from 'components/Icons';

import { InvoiceTeamOverview } from './TeamView';
import { ItemGroup } from '../../ItemGroup';
import { useAppWrapper } from '../../../WrapperContext';

import { useUser } from 'hooks';

import { hasWarning, sortControls } from './utils';

export function InvoiceProjects() {
  const { t } = useLang();
  const loggedUser = useUser();
  const { escapeDrawer } = useAppWrapper();

  const show = !!loggedUser.team.isInvoiceTeam;

  const { data, errorOrLoading } = loaders.invoice.invoiceControlByUsers.use({
    blockLoad: !show,

    realTimeSubscription: {
      type: 'INVOICE_CONTROL_ASSIGNMENT',

      onMessage: (assigned, controls = {}) => {
        const existsHere = !!controls[assigned.owner.id]?.controls?.find?.(
          ({ project }) => project.id === assigned.project.id,
        );

        return existsHere
          ? controls
          : {
              ...controls,

              [assigned.owner.id]: {
                ...controls[assigned.owner.id],

                total: (controls[assigned.owner.id]?.total ?? 0) + 1,

                controls: [
                  ...(controls[assigned.owner.id]?.controls ?? []),
                  assigned as unknown as InvoiceProjectByStatus,
                ],
              },
            };
      },
    },
  });

  if (errorOrLoading || !show || !data) return null;

  if (!data?.[loggedUser.id]) return <InvoiceTeamOverview teamControls={data} />;

  return (
    <>
      <ItemGroup
        name={t('my-projects')}
        icon={<FolderIcon size={22} />}
        itemKey="createdAt"
        items={sortControls(data[loggedUser.id].controls)}
        addErrorIndication={hasWarning(data[loggedUser.id].controls)}
        render={(entry) => (
          <Link
            className="flex items-center gap-3 pl-2 hover:underline"
            to="projectProfile"
            params={{ projectId: entry.project.id }}
            onClick={escapeDrawer}
          >
            {entry.addWarning ? (
              <WarningIcon
                size={14}
                color={getStatusConfig('invoiceControl', entry.status).color}
              />
            ) : (
              <Dot size={12} color={getStatusConfig('invoiceControl', entry.status).color} />
            )}

            <span className="break-words text-start text-xs font-semibold">
              {entry.project.name}
            </span>
          </Link>
        )}
      />

      <InvoiceTeamOverview teamControls={data} />
    </>
  );
}
